<script setup>
import { defineEmits } from "vue";

const symbolButtonList = ["AND", "OR", "NOT", "*", "\"\"", "()", "~"];

const emit = defineEmits(["insert-symbol"]);

function handleSymbolClick(symbol) {
  emit("insert-symbol", symbol);
}
</script>

<template>
  <div class="insert-symbol__list">
    <button
      v-for="symbol in symbolButtonList"
      :key="symbol"
      class="insert-symbol__button"
      @click="handleSymbolClick(symbol)"
    >
      {{ symbol }}
    </button>
  </div>
</template>

<style scoped lang="scss">

.insert-symbol__list {
  display: flex;
  gap: 6px;
}

.insert-symbol__button {
  cursor: pointer;
  user-select: none;
  padding: 6px 10px;
  height: 36px;
  border-radius: 8px;
  background-color: var(--background-bg-white);
  border: 1px solid var(--button-tertiary-neutral-bd-default);

  &:hover {
    background-color: var(--button-tertiary-neutral-hover);
  }
}

</style>